import { Box, Typography } from '@mui/material';
import { number, object } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const Statistics = ({ lastSeen = null, mandatoriesCount = 0, messagesSent = 0 }) => (
  <Box
    sx={{
      display: 'flex',
      minHeight: 80,
      alignItems: 'stretch',
      borderRadius: '8px',
      border: 'solid 1px #dde2eb',
      boxShadow: '0 1px 2px 0 rgba(2, 2, 3, 0.05)',
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'center',
        flex: 1,
        paddingLeft: '20px',
        borderRight: 'solid 1px #dde2eb',
        '&:last-child': {
          borderRight: 'none',
        },
      }}
    >
      <Typography
        sx={{
          fontSize: 15,
          fontWeight: 600,
          lineHeight: 1.47,
          letterSpacing: '-0.4px',
          color: 'text.primary',
        }}
      >
        {lastSeen?.isValid && lastSeen?.isValid()
          ? lastSeen.fromNow()
          : I18n.t('ProfileDrawer.never')}
      </Typography>
      <Typography
        sx={{
          fontSize: 15,
          lineHeight: 1.47,
          letterSpacing: '-0.5px',
          color: 'text.secondary',
        }}
      >
        {I18n.t('ProfileDrawer.Last seen')}
      </Typography>
    </Box>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'center',
        flex: 1,
        paddingLeft: '20px',
        borderRight: 'solid 1px #dde2eb',
        '&:last-child': {
          borderRight: 'none',
        },
      }}
    >
      <Typography
        sx={{
          fontSize: 15,
          fontWeight: 600,
          lineHeight: 1.47,
          letterSpacing: '-0.4px',
          color: 'text.primary',
        }}
      >
        {mandatoriesCount}
      </Typography>
      <Typography
        sx={{
          fontSize: 15,
          lineHeight: 1.47,
          letterSpacing: '-0.5px',
          color: 'text.secondary',
        }}
      >
        {I18n.t('ProfileDrawer.Sent mandatory reads')}
      </Typography>
    </Box>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'center',
        flex: 1,
        paddingLeft: '20px',
        borderRight: 'solid 1px #dde2eb',
        '&:last-child': {
          borderRight: 'none',
        },
      }}
    >
      <Typography
        sx={{
          fontSize: 15,
          fontWeight: 600,
          lineHeight: 1.47,
          letterSpacing: '-0.4px',
          color: 'text.primary',
        }}
      >
        {messagesSent}
      </Typography>
      <Typography
        sx={{
          fontSize: 15,
          lineHeight: 1.47,
          letterSpacing: '-0.5px',
          color: 'text.secondary',
        }}
      >
        {' '}
        {I18n.t('ProfileDrawer.Messages sent')}
      </Typography>
    </Box>
  </Box>
);
Statistics.propTypes = {
  lastSeen: object,
  mandatoriesCount: number,
  messagesSent: number,
};

export default Statistics;
